/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetShippingSourceInformationRequest
 */
export interface RequestGetShippingSourceInformationRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestGetShippingSourceInformationRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestGetShippingSourceInformationRequest interface.
 */
export function instanceOfRequestGetShippingSourceInformationRequest(value: object): value is RequestGetShippingSourceInformationRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestGetShippingSourceInformationRequestFromJSON(json: any): RequestGetShippingSourceInformationRequest {
    return RequestGetShippingSourceInformationRequestFromJSONTyped(json, false);
}

export function RequestGetShippingSourceInformationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetShippingSourceInformationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
    };
}

export function RequestGetShippingSourceInformationRequestToJSON(json: any): RequestGetShippingSourceInformationRequest {
    return RequestGetShippingSourceInformationRequestToJSONTyped(json, false);
}

export function RequestGetShippingSourceInformationRequestToJSONTyped(value?: RequestGetShippingSourceInformationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
    };
}

